// extracted by mini-css-extract-plugin
module.exports = {"header":"ITblpoov","headerContent":"xuIgrKNo","titleText":"b8CHDghS","subtitleSmall":"Owtd_D1d","bodySmall":"feyDiMO8"};